import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import JobArticleStore from '@src/pages/job-article/store';
import Page from '../../components/page';

import cx from 'classnames';
import Link from '@src/components/link';

const styles = require('./index.less');

const JobArticle = ({ store }) => {
  store.use();
  const getLocationLabel = item => {
    // 检查 item.locations 是否存在
    if (!item || !item.locations) return null;

    const locationLabels = item.locations
      .map(location => {
        const { city, province } = location;
        const hasCity = Boolean(city);
        const hasProvince = Boolean(province);

        if (!hasCity && !hasProvince) return null;

        return (
          <div className={styles.itemLocation}>
            {hasCity && city}
            {hasCity && hasProvince && ', '}
            {hasProvince && province}
          </div>
        );
      })
      .filter(label => label !== null);

    if (locationLabels.length === 0) return null;

    return locationLabels;
  };
  return (
    <Page className={styles.root}>
      {/* <div className={styles.naviBarBox}>
        <NaviBar />
      </div> */}

      <div className={styles.kv} />
      <div className={styles.test}> </div>
      <div className={styles.contentBox}>
        <div className={styles.content}>
          <div className={styles.jobArticle}>
            <div className={cx(styles.jobTitle)}>
              {store.prior === '1' && <div className={styles.iconHotspot} />}
              {store.jobInfo.title}
            </div>
            <div className={styles.jobLabelInfo}>
              {/* <div className={styles.itemLabel}>{store.jobInfo.department && store.jobInfo.department.name}</div> */}
              <div className={styles.itemLabel}>{store.jobInfo.commitment}</div>
              <div className={styles.itemLabel}>{store.jobInfo.zhineng && store.jobInfo.zhineng.name}</div>
              {getLocationLabel(store.jobInfo)}
              {/* <div className={styles.itemLabel}>
                {store.jobInfo.locations?.[0]?.city}, {store.jobInfo.locations?.[0]?.province}
              </div> */}
            </div>
            <div className={styles.jobDescription}>
              <div className={styles.title}>{store.pageConfig.job_description}</div>
              <div className={styles.infoList} dangerouslySetInnerHTML={{ __html: store.jobInfo.description }}>
                {/* <p>1. Based on the IP and director's requirements, break down and design the plot flow to form a task outline;</p>
                <p>2. Collaborate with art and programming to integrate art and development resources;</p>
                <p>3. Assemble and maintain the task process;</p>
                <p>
                  4. Undertake communication and coordination with upstream and downstream stakeholders, and comprehensively manage the task implementation
                  process.
                </p> */}
              </div>
            </div>
            {/* <div className={styles.jobInfo}>
              <div className={styles.title}>{store.pageConfig.job_date}</div>
              <div className={styles.list}>
                <div className={styles.itemBox}>
                  <div className={styles.label}>{store.pageConfig.job_title}</div>
                  <div className={styles.text}>{store.jobInfo.title}</div>
                </div>
                <div className={styles.itemBox}>
                  <div className={styles.label}>{store.pageConfig.job_range}</div>
                  <div className={styles.text}>
                    {`${store.jobInfo.minSalary ? store.jobInfo.minSalary + 'k' : ''}-${store.jobInfo.maxSalary ? store.jobInfo.maxSalary + 'k' : ''}`}
                  </div>
                </div>
                <div className={styles.itemBox}>
                  <div className={styles.label}>{store.pageConfig.job_type}</div>
                  <div className={styles.text}>{store.jobInfo.commitment}</div>
                </div>
                <div className={styles.itemBox}>
                  <div className={styles.label}>{store.pageConfig.job_function}</div>
                  <div className={styles.text}>{store.jobInfo.zhineng?.name}</div>
                </div>
                <div className={styles.itemBox}>
                  <div className={styles.label}>{store.pageConfig.job_department}</div>
                  <div className={styles.text}>{store.jobInfo.department?.name}</div>
                </div>
                <div className={styles.itemBox}>
                  <div className={styles.label}>{store.pageConfig.job_location}</div>
                  <div className={styles.text}>
                    {store.getPinYinData(store.jobInfo.locations?.[0]?.city)}, {store.getPinYinData(store.jobInfo.locations?.[0]?.province)}
                  </div>
                </div>
                <div className={styles.itemBox}>
                  <div className={styles.label}>{store.pageConfig.job_date}</div>
                  <div className={styles.text}> {store.jobInfo.openedAt ? DateUtil.formatDate(new Date(store.jobInfo.openedAt), 'yyyy/MM/dd') : '-'}</div>
                </div>
              </div>
            </div> */}

            <div className={styles.btnBox}>
              <Link
                className={styles.btnApply}
                onClick={() => {
                  store.onApplyClick();
                }}
              >
                {store.pageConfig.job_send}
              </Link>
            </div>
          </div>
          <div className={cx(styles.relatedPositionsBox, store.jobList.length === 0 && styles.not)}>
            <div className={styles.relatedPositionsTitle}>{store.pageConfig.related_positions}</div>

            {store.jobList.length > 0 ? (
              <div className={styles.list}>
                {store.jobList.map((item, index) => {
                  return (
                    <Link
                      className={styles.item}
                      key={index}
                      onClick={() => store.clickJob(item)}
                    //  href={`/#/jobArticle?jobId=${item.id}&prior=${item.prior}`}
                    // href={`jobArticle.html?jobId=${item.id}&prior=${item.prior}`}

                    //  target={'_blank'}
                    >
                      <div className={cx(styles.title, item.prior === 1 && styles.hotspot)}>
                        <div className={styles.titleText}>{item.title}</div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            ) : (
              <div className={styles.notStatus}>
                <div className={styles.icon} style={{ backgroundImage: `url("${store.pageConfig.not_data_img}")` }} />
                <div className={styles.text}>{store.pageConfig.not_data_text}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default wrapStore(JobArticle, JobArticleStore);
